/* eslint-disable prettier/prettier */
import { setStoreValue } from '@/store/utils';
import { INITIAL_BOOKING_STATE } from '@/store/modules/bookings/bookings';

export const SET_IS_FETCHING_BOOKINGS = "SET_IS_FETCHING_BOOKINGS";
export const SET_IS_FETCHING_CURRENT_BOOKING = "SET_IS_FETCHING_CURRENT_BOOKING";
export const SET_IS_FETCHING_CURRENT_BOOKING_CANDIDATES = "SET_IS_FETCHING_CURRENT_BOOKING_CANDIDATES";
export const SET_IS_FETCHING_CURRENT_BOOKING_COMMENTS = "SET_IS_FETCHING_CURRENT_BOOKING_COMMENTS";
export const SET_IS_FETCHING_CURRENT_BOOKING_PUBLISHING_SCHEDULE = "SET_IS_FETCHING_CURRENT_BOOKING_PUBLISHING_SCHEDULE";
export const SET_BOOKINGS = "SET_BOOKINGS";
export const SET_CURRENT_BOOKING = "SET_CURRENT_BOOKING";
export const SET_CURRENT_BOOKING_COMMENTS = "SET_CURRENT_BOOKING_COMMENTS";
export const SET_CURRENT_BOOKING_CANDIDATES = "SET_CURRENT_BOOKING_CANDIDATES";
export const SET_CURRENT_BOOKING_PUBLISHING_SCHEDULE = "SET_CURRENT_BOOKING_PUBLISHING_SCHEDULE";
export const CLEAR_BOOKING_DETAILS = "CLEAR_BOOKING_DETAILS";
export const UPDATE_LOCAL_APPLICATION = 'UPDATE_LOCAL_APPLICATION';
export const SET_IS_FETCHING_CANDIDATES_FOR_SUBMIT = 'SET_IS_FETCHING_CANDIDATES_FOR_SUBMIT';
export const SET_CANDIDATES_FOR_SUBMIT = 'SET_CANDIDATES_FOR_SUBMIT';
export const SET_EVALUATION_STATUSES = 'SET_EVALUATION_STATUSES';
export const SET_IS_FETCHING_SHARING_USERS = 'SET_IS_FETCHING_SHARING_USERS';
export const SET_SHARING_USERS = 'SET_SHARING_USERS';
export const SET_BOOKING_OPTIONS = 'SET_BOOKING_OPTIONS';
export const SET_IS_FETCHING_BOOKING_OPTIONS = 'SET_IS_FETCHING_BOOKING_OPTIONS';
export const SET_IS_FETCHING_USERS_FOR_SHARING = 'SET_IS_FETCHING_USERS_FOR_SHARING';
export const SET_USERS_FOR_SHARING = 'SET_USERS_FOR_SHARING';
export const SET_BOOKING_LIST_FILTERS = 'SET_BOOKING_LIST_FILTERS';
export const SET_PUBLISHING_CHANNELS = 'SET_PUBLISHING_CHANNELS';
export const SET_IS_FETCHING_PUBLISHING_CHANNELS = 'SET_IS_FETCHING_PUBLISHING_CHANNELS';

const bookingsMutations = {
  [SET_IS_FETCHING_BOOKINGS]: setStoreValue("isFetchingBookings"),
  [SET_BOOKINGS]: setStoreValue("bookings"),
  [SET_CURRENT_BOOKING]: setStoreValue("currentBooking"),
  [SET_CURRENT_BOOKING_COMMENTS]: setStoreValue("bookingComments"),
  [SET_CURRENT_BOOKING_CANDIDATES]: setStoreValue("currentBookingCandidates"),
  [SET_CANDIDATES_FOR_SUBMIT]: setStoreValue("candidatesForSubmit"),
  [SET_IS_FETCHING_CANDIDATES_FOR_SUBMIT]: setStoreValue("isFetchingCandidatesForSubmit"),
  [SET_CURRENT_BOOKING_PUBLISHING_SCHEDULE]: setStoreValue("currentBookingPublishingSchedule"),
  [SET_IS_FETCHING_CURRENT_BOOKING]: setStoreValue("isFetchingCurrentBooking"),
  [SET_IS_FETCHING_CURRENT_BOOKING_CANDIDATES]: setStoreValue("isFetchingCurrentBookingCandidates"),
  [SET_IS_FETCHING_CURRENT_BOOKING_COMMENTS]: setStoreValue("isFetchingBookingComments"),
  [SET_IS_FETCHING_CURRENT_BOOKING_PUBLISHING_SCHEDULE]: setStoreValue("isFetchingBookingPublishingSchedule"),
  [SET_EVALUATION_STATUSES]: setStoreValue("evaluationStatuses"),
  [CLEAR_BOOKING_DETAILS](state, currentBookingId) {
    const savedBookingId = state.currentBooking && state.currentBooking.id;
    if(savedBookingId !== currentBookingId) {
      state.currentBooking = INITIAL_BOOKING_STATE.currentBooking;
    }
    state.bookingComments = INITIAL_BOOKING_STATE.bookingComments;
    state.currentBookingCandidates = INITIAL_BOOKING_STATE.currentBookingCandidates;
    state.currentBookingPublishingSchedule = INITIAL_BOOKING_STATE.currentBookingPublishingSchedule;
    state.currentBookingEvents = INITIAL_BOOKING_STATE.currentBookingEvents;
    return state;
  },
  [UPDATE_LOCAL_APPLICATION](state,editedApplication) {
    state.currentBookingCandidates = state.currentBookingCandidates.map(
      application => {
        return application.id === editedApplication.id
          ? editedApplication
          : application;
      }
    )
  },
  [SET_IS_FETCHING_SHARING_USERS]: setStoreValue("isFetchingSharingUsers"),
  [SET_SHARING_USERS]: setStoreValue("sharingUsers"),
  [SET_BOOKING_OPTIONS]: setStoreValue("bookingOptions"),
  [SET_IS_FETCHING_BOOKING_OPTIONS]: setStoreValue("isFetchingBookingOptions"),
  [SET_IS_FETCHING_USERS_FOR_SHARING]: setStoreValue("isFetchingSharingUsers"),
  [SET_USERS_FOR_SHARING]: setStoreValue("usersForSharing"),
  [SET_BOOKING_LIST_FILTERS]: setStoreValue("bookingListFilters"),
  [SET_PUBLISHING_CHANNELS]: setStoreValue("publishingChannels"),
  [SET_IS_FETCHING_PUBLISHING_CHANNELS]: setStoreValue("isFetchingPublishingChannels")
};

export default bookingsMutations;
